import { SVGProps } from "react"

export const GorgiasIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={37}
      height={37}
      viewBox="0 0 37 37"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path d="M29.9703 8.77433H24.6131V3.41003C24.6131 1.83553 23.3393 0.560059 21.7669 0.560059H2.84619C1.27378 0.560059 0 1.83553 0 3.41003V30.5702C0 32.1447 1.27378 33.4202 2.84619 33.4202H27.3466L29.9977 36.0749C30.3085 36.3861 30.726 36.5601 31.1648 36.5601C32.076 36.5601 32.8165 35.8216 32.8165 34.9062V11.6243C32.8165 10.0498 31.5427 8.77433 29.9703 8.77433ZM30.083 30.6801H2.73344V3.29713H21.8766V8.77433H11.0495C9.47713 8.77433 8.20336 10.0498 8.20336 11.6243V22.356C8.20336 23.9305 9.47713 25.2059 11.0495 25.2059H21.7669C23.3393 25.2059 24.6131 23.9305 24.6131 22.356V11.5145H30.083V30.6831V30.6801ZM21.8797 11.5114V22.4658H10.9398V11.5114H21.8797Z" />
    </svg>
  )
}
